/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1684
 */

var r = require(/* 86 */"../1650/86/index")
var o = require(/* 1260 */"./1260")
r({
  global: true,
  forced: parseFloat != o
}, {
  parseFloat: o
})
